import { FilterOption } from "../types";

export enum FilterValues {
    ALL = 'all',
    STORES = 'stores',
    CHECKOUT = 'checkout',
    PAYMENT_LINKS = 'payment_links',
    SIDE_LOADING = 'side_loading',
    GAME_PORTALS = 'game_portals',
    PARKING_DOMAIN = 'parking_domain'
}

export enum SortValues {
    EMPTY = '',
    ALPHABETIC = 'alphabetic',
    LAST_VIEWED = 'lastViewed',
    STARRED = 'starred'
}

export enum ViewMode {
    GRID = 'grid',
    LIST = 'list'
}

export enum ProjectCategory {
    PROJECT = 'project',
    PORTAL = 'portal',
    PARKING_DOMAIN = 'parking_domain'
}

export enum ProjectConfigKey {
    PORTAL = 'portal',
    PAYMENT_LINKS = 'payment_links',
    STORE = 'store',
    CHECKOUT = 'checkout',
    SIDE_LOADING = 'side_loading',
    PARKING_DOMAIN = 'parking_domain'
}

export const DEFAULT_FILTER = FilterValues.ALL;
export const DEFAULT_SORT = SortValues.ALPHABETIC;
export const DEFAULT_VIEW = ViewMode.LIST;

export const PROJECT_TYPE_FILTERS: FilterOption[] = [
    { label: 'All projects', value: FilterValues.ALL },
    { label: 'Game portal', value: FilterValues.GAME_PORTALS },
    { label: 'Store', value: FilterValues.STORES },
    { label: 'Web checkout', value: FilterValues.CHECKOUT },
    { label: 'Payment link', value: FilterValues.PAYMENT_LINKS },
    { label: 'AppDirect', value: FilterValues.SIDE_LOADING },
    { label: 'Parking domain', value: FilterValues.PARKING_DOMAIN }
];

export const SORT_OPTIONS: FilterOption[] = [
    { label: 'Sort by', value: SortValues.EMPTY, disabled: true },
    { label: 'Last Viewed', value: SortValues.LAST_VIEWED },
    { label: 'Alphabetic', value: SortValues.ALPHABETIC },
    { label: 'Starred', value: SortValues.STARRED }
];

export const PROJECT_CONFIG = {
    [ProjectConfigKey.PORTAL]: {
        label: 'Game Portal',
        icon: 'fa-regular fa-table-layout',
        bgColor: 'bg-violet-100 text-zinc-600'
    },
    [ProjectConfigKey.PAYMENT_LINKS]: {
        label: 'Payment Link',
        icon: 'fa-regular fa-square-up-right',
        bgColor: 'bg-zinc-200 text-zinc-600'
    },
    [ProjectConfigKey.STORE]: {
        label: 'Store',
        icon: 'fa-regular fa-store',
        bgColor: 'bg-green-200 text-zinc-600'
    },
    [ProjectConfigKey.CHECKOUT]: {
        label: 'Web checkout',
        icon: 'fa-regular fa-credit-card',
        bgColor: 'bg-amber-100 text-zinc-600'
    },
    [ProjectConfigKey.SIDE_LOADING]: {
        label: 'AppDirect',
        icon: 'fa-regular fa-arrow-down-from-arc',
        bgColor: 'bg-orange-200 text-zinc-600'
    },
    [ProjectConfigKey.PARKING_DOMAIN]: {
        label: 'Parking Domain',
        icon: 'fa-light fa-money-check-dollar',
        bgColor: 'bg-sky-100 text-zinc-600'
    }
} as const;